<template>
    <div class="form-content-wrapper">

        <div class="action-browse-wrapper">
            <b-form-file v-model="input" name="fotoBarangPendukung" :state="Boolean(foto)"
                drop-placeholder="Drop file here..." accept=".jpg, .png, .jpeg" @input="browseFile()">
            </b-form-file>
            <b-button variant="cancelBtn">
                <i class="fa fa-upload mr-2"></i>
                Upload Foto
            </b-button>
            <!-- <b-button variant="success" class="mt-2" @click="uploadViaPresignedUrl(input)">
        <i class="fa fa-cloud-upload mr-2"></i>
        Upload via Presigned URL
    </b-button> -->

        </div>


        <b-table bordered hover show-empty :fields="fields" :busy="isBusy" :items="foto" responsive class="mb-3">

            <template v-slot:table-busy>
                <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong> Loading data...</strong>
                </div>
            </template>
            <template v-slot:empty>
                Tidak ada data.
            </template>
            <template v-slot:cell(foto)="row">
                <a target="_blank">
                    <img width="130px" height="130px"
                        :src="row.item.name">
                </a>
            </template>
            <template v-slot:cell(aksi)="row">
                <b-button class="btn btn-sm" variant="danger" @click="confirmDeleteFoto(row.item.id)">
                    <i class="fa fa-trash"></i>
                </b-button>
            </template>
        </b-table>

        <b-modal id="modal-loading" centered size="sm" hide-footer hide-header no-close-on-esc no-close-on-backdrop>
           <h4 class="text-center text-lg">LOADING ...</h4>
        </b-modal>

        <ModalConfirm id="confirm-hapus-foto" title="Konfirmasi hapus Foto" :isSubmitting="isBusy"
            desc="Apakah anda yakin untuk menghapus foto ini?" @submit="onDeleteFoto()" />
    </div>
</template>

<script>

export default {
    props: {
        rincian: {
            type: Object,
            required: true
        },
        idTipe: {
            type: Number,
            default: null
        }
    },
    components: {

    },
    data() {
        return {
            id: null,
            initStatus: 0,
            isSubmitting: false,
            isBusy: true,


            tipeBarang: null,
            activeId: null,
            foto: [],
            input: null,

            fields: [
                { key: "foto", label: "Foto" },
                { key: "aksi", label: "Aksi" }
            ],

            presignedUrl: "",
        }
    },
    methods: {
        init() {
            this.initStatus = 0
            this.id = (this.idTipe != null) ? this.idTipe : this.$route.params.id

            let getSingleTipeBarang = this.$axios.get(`barang-tipe-v2/${this.id}`).then(response => {
                this.tipeBarang = response.data
                this.foto = response.data.foto
                let msg = this.$helper.getFlash()
                this.toggleBusy()
                this.$helper.toastSucc(this, msg)
            })

            Promise.all([getSingleTipeBarang]).then(() => {
                this.initStatus = 1
            })
                .catch(() => {
                    this.initStatus = -1
                })

        },
        fetchData() {
            this.toggleBusy()
            this.hargaSesuaiTahun = false
            this.$axios.get(`barang-tipe-v2/${this.id}`).then(response => {
                this.tipeBarang = response.data
                this.foto = response.data.foto
                this.toggleBusy()
            }).catch(() => {
                this.initStatus = -1
            })
        },

        confirmDeleteFoto(id) {
            this.activeId = id
            this.$bvModal.show("confirm-hapus-foto")
        },

        onDeleteFoto() {
            this.$bvModal.show('modal-loading')
            this.$axios.post(`barang-tipe-v2/delete-photo?photoId=` + this.activeId).then(() => {

                this.$bvModal.hide("confirm-hapus-foto")
                this.$helper.toastSucc(this, 'Data berhasil dihapus')
                this.fetchData()
                this.$bvModal.hide('modal-loading')
            })
                .catch(error => {
                    this.$bvModal.hide('modal-loading')
                    this.$helper.parseError(this, error)
                })
        },

        toggleBusy() {
            if (this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        browseFile() {
            this.$bvModal.show('modal-loading')

            // formData.append('tipeId', this.id);
            // formData.append('photo', this.input);
            this.uploadViaPresignedUrl(this.input)
        },

        getPresignedUrl() {
            this.$axios.get(`s3/?contentType=image&tipeId=${this.id}`).then(response => {
                this.presignedUrl = response.data.name

                // this.uploadViaPresignedUrl(this.input)
            }).catch(error => {
                this.$helper.parseError(this, error)
            })
        },

        uploadViaPresignedUrl(file) {
        this.$bvModal.show('modal-loading')

        fetch(this.presignedUrl, {
            method: 'PUT',
            headers: {
                'Content-Type': "image"
            },
            body: file
        }).then(response => {

            if (!response.ok) {
                throw new Error('Upload failed')
            }
            this.$helper.toastSucc(this, "Upload foto berhasil!")

            const newData = `?tipeId=${Number(this.id)}&pathPhoto=${this.presignedUrl.split('?')[0]}`
                
                this.$axios.post(`barang-tipe-v2/insert-photo${newData}`, {

                }).then(() => {
                    this.fetchData()
                    this.getPresignedUrl()
                    this.$bvModal.hide('modal-loading')
                    this.$helper.toastSucc(this, "foto berhasil diupload!")
                }).catch(() => {
                    // Tindakan jika terjadi kesalahan
                    this.initStatus = -1;
                    this.$bvModal.hide('modal-loading')
                });
        }).catch(() => {
            this.$bvModal.hide('modal-loading')
            this.$helper.toastErr(this, "Upload via presigned URL gagal.")
        })
    }


    },
    watch: {

        //----------------- Pantau Filter Jenis Barang -----------------

    },
    created() {
        this.init()
        this.getPresignedUrl()
    }
}
</script>